"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.apiDelete = exports.apiPatch = exports.apiPut = exports.apiPost = exports.apiGet = void 0;
var axios_1 = __importDefault(require("axios"));
var store_1 = require("../store");
var _apiBaseURL = process.env.API_URL;
var objToQueryString = function (obj) {
    // the object could be null
    if (Object.keys(obj !== null && obj !== void 0 ? obj : {}).length === 0) {
        return "";
    }
    // also prepend the ?
    return ("?" +
        Object.keys(obj)
            .map(function (key) { return key + "=" + obj[key]; })
            .join("&"));
};
var apiGet = function (_a) {
    var authorization = _a.authorization, endpoint = _a.endpoint, contentType = _a.contentType, query = _a.query, customHeaders = _a.customHeaders;
    return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, (0, axios_1.default)({
                        method: "GET",
                        url: "".concat(_apiBaseURL, "/").concat(endpoint).concat(objToQueryString(query)),
                        headers: getHeaders({ authorization: authorization, contentType: contentType, customHeaders: customHeaders }),
                        // headers: {
                        //   Authorization: `Bearer ${userState.user.token}`,
                        //   "content-type": "application/json",
                        //   client_token: userState.user.client_token,
                        // },
                    })
                        .then(function (response) {
                        //       console.log(`api -> apiGet -> calls -> ${endpoint} SUCCESS:`, response);
                        return response;
                    })
                        .catch(function (error) {
                        //       console.log(`api -> apiGet -> calls -> ${endpoint} ERROR:`, error);
                        return extractErrorMessage(error);
                    })];
                case 1: return [2 /*return*/, _b.sent()];
            }
        });
    });
};
exports.apiGet = apiGet;
var apiPost = function (_a) {
    var authorization = _a.authorization, endpoint = _a.endpoint, contentType = _a.contentType, data = _a.data, customHeaders = _a.customHeaders, uploadProgress = _a.uploadProgress;
    return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, (0, axios_1.default)({
                        method: "POST",
                        url: "".concat(_apiBaseURL, "/").concat(endpoint),
                        headers: getHeaders({ authorization: authorization, contentType: contentType, customHeaders: customHeaders }),
                        // headers: {
                        //   Authorization: `Bearer ${userState.user.token}`,
                        //   "content-type": contentType ? contentType : "application/json",
                        //   client_token: userState.user.client_token,
                        // },
                        data: data,
                        onUploadProgress: function (progressEvent) {
                            var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                            if (uploadProgress) {
                                uploadProgress(percentCompleted);
                            }
                        },
                    })
                        .then(function (response) {
                        //       console.log(`api -> apiPost -> calls -> ${endpoint} SUCCESS:`, response);
                        return response;
                    })
                        .catch(function (error) {
                        //       console.log(`api -> apPost -> calls -> ${endpoint} ERROR:`, error);
                        return extractErrorMessage(error);
                    })];
                case 1: return [2 /*return*/, _b.sent()];
            }
        });
    });
};
exports.apiPost = apiPost;
var apiPut = function (_a) {
    var authorization = _a.authorization, endpoint = _a.endpoint, contentType = _a.contentType, data = _a.data, customHeaders = _a.customHeaders;
    return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, (0, axios_1.default)({
                        method: "PUT",
                        url: "".concat(_apiBaseURL, "/").concat(endpoint),
                        headers: getHeaders({ authorization: authorization, contentType: contentType, customHeaders: customHeaders }),
                        // headers: {
                        //   Authorization: `Bearer ${userState.user.token}`,
                        //   "content-type": contentType ? contentType : "application/json",
                        //   client_token: userState.user.client_token,
                        // },
                        data: data,
                    })
                        .then(function (response) {
                        //       console.log(`api -> apiPut -> calls -> ${endpoint} SUCCESS:`, response);
                        return response;
                    })
                        .catch(function (error) {
                        //       console.log(`api -> apiPut -> calls -> ${endpoint} ERROR:`, error);
                        return extractErrorMessage(error);
                    })];
                case 1: return [2 /*return*/, _b.sent()];
            }
        });
    });
};
exports.apiPut = apiPut;
var apiPatch = function (_a) {
    var authorization = _a.authorization, endpoint = _a.endpoint, contentType = _a.contentType, data = _a.data, customHeaders = _a.customHeaders;
    return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, (0, axios_1.default)({
                        method: "PATCH",
                        url: "".concat(_apiBaseURL, "/").concat(endpoint),
                        headers: getHeaders({ authorization: authorization, contentType: contentType, customHeaders: customHeaders }),
                        // headers: {
                        //   Authorization: `Bearer ${userState.user.token}`,
                        //   "content-type": contentType ? contentType : "application/json",
                        //   client_token: userState.user.client_token,
                        // },
                        data: data,
                    })
                        .then(function (response) {
                        //       console.log(`api -> apiPatch -> calls -> ${endpoint} SUCCESS:`, response);
                        return response;
                    })
                        .catch(function (error) {
                        //       console.log(`api -> apiPatch -> calls -> ${endpoint} ERROR:`, error);
                        return extractErrorMessage(error);
                    })];
                case 1: return [2 /*return*/, _b.sent()];
            }
        });
    });
};
exports.apiPatch = apiPatch;
var apiDelete = function (_a) {
    var authorization = _a.authorization, endpoint = _a.endpoint, contentType = _a.contentType, data = _a.data, customHeaders = _a.customHeaders;
    return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, (0, axios_1.default)({
                        method: "DELETE",
                        url: "".concat(_apiBaseURL, "/").concat(endpoint),
                        headers: getHeaders({ authorization: authorization, contentType: contentType, customHeaders: customHeaders }),
                        // headers: {
                        //   Authorization: `Bearer ${userState.user.token}`,
                        //   "content-type": contentType ? contentType : "application/json",
                        //   client_token: userState.user.client_token,
                        // },
                        data: data,
                    })
                        .then(function (response) {
                        //       console.log(`api -> apiPost -> calls -> ${endpoint} SUCCESS:`, response);
                        return response;
                    })
                        .catch(function (error) {
                        //       console.log(`api -> apPost -> calls -> ${endpoint} ERROR:`, error);
                        return extractErrorMessage(error);
                    })];
                case 1: return [2 /*return*/, _b.sent()];
            }
        });
    });
};
exports.apiDelete = apiDelete;
function getHeaders(params) {
    var _a, _b;
    var state = store_1.redux_store.getState();
    var userState = state.userState;
    var objHeaders = {};
    objHeaders["ngrok-skip-browser-warning"] = true;
    objHeaders["content-type"] = (_a = params.contentType) !== null && _a !== void 0 ? _a : "application/json";
    objHeaders.authorization = "Bearer ".concat((_b = params.authorization) !== null && _b !== void 0 ? _b : userState.user.token);
    if (params.customHeaders) {
        objHeaders = __assign(__assign({}, objHeaders), params.customHeaders);
    }
    return objHeaders;
}
//Private Functions
var extractErrorMessage = function (error) {
    var _a, _b, _c, _d, _e, _f;
    var message = error;
    if (error.response) {
        // The client was given an error response (5xx, 4xx)
        //     console.log("Error", error.response);
        if (error.response.status == 0) {
            message = "Client could not connect to the server";
        }
        else {
            // message = "Client was given an error response";
            if ((_c = (_b = (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.content) === null || _c === void 0 ? void 0 : _c.errors) {
                // loop over the array. and look at the kay & message to build the error message
                var errors = (_f = (_e = (_d = error === null || error === void 0 ? void 0 : error.response) === null || _d === void 0 ? void 0 : _d.data) === null || _e === void 0 ? void 0 : _e.content) === null || _f === void 0 ? void 0 : _f.errors;
                message = "";
                errors === null || errors === void 0 ? void 0 : errors.forEach(function (element) {
                    message += "".concat(element === null || element === void 0 ? void 0 : element.key, ": ").concat(element === null || element === void 0 ? void 0 : element.message, "\n");
                });
            }
            else {
                message = "Client could not connect to the server";
            }
        }
        // message = "Client was given an error response";
    }
    else if (error.request) {
        message = "Client request never left the browser and therefore never received a response from the server ";
    }
    else {
        // Anything else
        //     console.log("Error", error.message);
        message = error.message;
    }
    //Simulate a normal response so that it wont break the UI.
    return {
        data: {
            success: false,
            message: message,
            content: error,
        },
    };
};
